import React from 'react';

interface FontOption {
  name: string;
  value: string;
}

const DEFAULT_FONTS: FontOption[] = [
  { name: 'Bree Serif', value: 'Bree Serif' },
  { name: 'Fondamento', value: 'Fondamento' },
  { name: 'Itim', value: 'Itim' },
  { name: 'Joti One', value: 'Joti One' },
  { name: 'Love Ya Like A Sister', value: 'Love Ya Like A Sister' },
  { name: 'Marmelad', value: 'Marmelad' },
  { name: 'Mogra', value: 'Mogra' },
  { name: 'Risque', value: 'Risque' },
  { name: 'Salsa', value: 'Salsa' },
  { name: 'Open Sans', value: 'Open Sans' },
  { name: 'Delius', value: 'Delius' },
  { name: 'Sofia One', value: 'Sofia One' },
];

interface FontPickerProps {
  selectedFont: string;
  onFontSelect: (font: string) => void;
  allowedFonts?: FontOption[];
}

export const FontPicker: React.FC<FontPickerProps> = ({
  selectedFont,
  onFontSelect,
  allowedFonts,
}) => {
  // Use allowed fonts if provided, otherwise use defaults
  const fonts = allowedFonts && allowedFonts.length > 0 ? allowedFonts : DEFAULT_FONTS;

  return (
    <div className="space-y-1">
      <div className="grid grid-cols-4 gap-1">
        {fonts.map((font) => (
          <button
            key={font.value}
            onClick={() => onFontSelect(font.value)}
            className={`px-1 py-1.5 rounded-lg border transition-all ${
              selectedFont === font.value
                ? 'border-red-500 shadow-sm'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <div
              className="text-base text-center truncate"
              style={{ fontFamily: font.value }}
            >
              Texte
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};